import { WidgetsHandler } from '@sitecore-search/core';
import { init as initSDK } from '@sitecore-search/widgets';
import * as handler from './handler.js';
import setupAllWidgets from './setupAllWidgets.js';
import ReactWidgetFactory from './widgetFactory.js';
export const init = (...args) => {
    setupAllWidgets();
    handler.init(new WidgetsHandler(), new ReactWidgetFactory());
    initSDK(...args);
};
